'use client';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import logoImg from '@/public/Logo-1.png';

export function Header() {
  const pathname = usePathname();

  const isActive = (path: string) => pathname === path;

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-md">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link href="/" className="flex items-center gap-3">
          <Image src={logoImg} alt="SISCE Logo" className="h-12 w-auto" priority />
        </Link>

        <div className="flex items-center gap-8">
          <Link
            href="/home"
            className={`transition-colors ${
              isActive('/home')
                ? 'text-(--sisce-navy)'
                : 'text-foreground/70 hover:text-(--sisce-navy)'
            }`}
          >
            Início
          </Link>

          <Link
            href="/funcionalidades"
            className={`transition-colors ${
              isActive('/funcionalidades')
                ? 'text-(--sisce-navy)'
                : 'text-foreground/70 hover:text-(--sisce-navy)'
            }`}
          >
            Funcionalidades
          </Link>

          <Link
            href="/planos"
            className={`transition-colors ${
              isActive('/planos')
                ? 'text-(--sisce-navy)'
                : 'text-foreground/70 hover:text-(--sisce-navy)'
            }`}
          >
            Planos
          </Link>

          <Link
            href="/contato"
            className={`transition-colors ${
              isActive('/contato')
                ? 'text-(--sisce-navy)'
                : 'text-foreground/70 hover:text-(--sisce-navy)'
            }`}
          >
            Contato
          </Link>

          <a
            href="/login"
            className="rounded-lg bg-linear-to-r from-(--sisce-cyan) to-(--sisce-pink) px-6 py-2.5 text-white transition-opacity hover:opacity-90"
          >
            Entrar
          </a>
        </div>
      </nav>
    </header>
  );
}
